import { JSX } from "react";

import { Box, Theme, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { type IntervalTab } from "./enum/IntervalTab";

const getStyles = (theme: Theme) => ({
  flexContainer: {
    fontSize: theme.fontSizes.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: theme.palette.text.secondary,
  },
});

function TabLabel({ intervalTab }: { intervalTab: IntervalTab }): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();
  return <Box sx={getStyles(theme).flexContainer}>{t(intervalTab.toString()).toUpperCase()}</Box>;
}

export default TabLabel;
